import React, { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import Modal from "../Modal/Modal";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  filterResultLoading,
  getCurrentPageHumatars,
  getHasMoreHumatars,
  getHumatarList,
  getHumatarListLoading,
  searchResultLoading,
} from "../../redux/reducers/humatarReducer";
import { Humatar, HumatarPrefilled, HumatarPreviewPrefilled } from "../../types/humatar";
import { useDispatch } from "react-redux";
import {
  bookmarkHumatarServer,
  clearHumatars,
  clearSearch,
  filterHumatarLoading,
  getHumatarsServer,
  searchHumatarResultLoading,
} from "../../redux/actions/humatarActions";
import { Filter } from "../../types/filter";
import debounce from "lodash.debounce";
import { toast } from "react-toastify";
import { VideoEditorContext } from "../../App";
import { Popups, updatePopup } from "../../redux/actions/popupsActions";
import { ActorPositionTypes } from "../../types/scene";
import { getPrefilled } from "../../redux/reducers/popupsReducer";
import { ConfirmationDelete, DeleteType } from "../../types/confirmationDelete";
import NewHumanCard from "../HumanCard/NewHumanCard";
import { ImageTag } from "../../modules/AIHumans/components/tabs/tabs.styles";
import { humatarAPIFilters, HumatarProps, humatarTabs } from "../../mocks/humans";
import Tabs from "../../modules/AIHumans/components/Tabs";
import ContentLoader from "react-content-loader";

export type SetSelectedActor = (humatar: Humatar) => void;

export interface FilterAIHumans {
  categoryType: string[];
  voiceAge: string[];
  isFeMale: string[];
  region: string[];
}

interface Props {
  canvasSize: { width: number; height: number };
  open: boolean;
  onClose: () => void;
}

function getWindowDimensions() {
  const { innerWidth: width } = window;
  return {
    width,
  };
}

const searchTimeoutDelay = 500;

const AIHumansPopup = ({ canvasSize, open, onClose }: Props) => {
  const { handleAddAvatar } = useContext(VideoEditorContext);
  const dispatch = useDispatch();
  const isFirstRender = useRef(true);
  const humatarPrefilled: HumatarPrefilled = useSelector(getPrefilled);
  const [screen, setScreen] = useState({
    popular: false,
    history: false,
    bookmark: false,
  });
  const humans = useSelector(getHumatarList);
  const hasMore = useSelector(getHasMoreHumatars);
  const isLoading = useSelector(getHumatarListLoading);
  const currentPage = useSelector(getCurrentPageHumatars);
  const searchLoading = useSelector(searchResultLoading);
  const filterLoading = useSelector(filterResultLoading);
  const [active, setActive] = useState<Humatar>();
  const [search, setSearch] = useState("");
  const [openMobileSelectList, setOpenMobileSelectList] = useState<boolean>(false);
  const [windowDimensions, setWindowDimensions] = useState<Record<string, number>>(getWindowDimensions());
  const setSelectedActor: SetSelectedActor = (humatar: Humatar) => {
    setActive(humatar);
  };

  const prefilled = humatarPrefilled && humatarPrefilled.category ? humatarPrefilled : humatarPrefilled?.previousFill;

  // for new tabs
  const [activeTab, setActiveTab] = useState(HumatarProps.ALL_AVATARS);

  const [filters, setFilters] = useState<Filter>({
    categoryType: [],
    voiceAge: [],
    isFeMale: [],
    mood: [],
    content: [],
    region: [],
    country: [],
    language: [],
    category: [],
  });

  // const allFilters = filters.categoryType
  //   .concat(filters.voiceAge, filters.isFeMale, filters.region, filters.category)
  //   .map((item) => {
  //     const filterObjArray = Object.entries(filters).map(([key, value]) => {
  //       return {
  //         key,
  //         value,
  //       };
  //     });

  //     const newKey = filterObjArray?.find(({ value }) => value.includes(item))?.key;

  //     return {
  //       key: newKey,
  //       item,
  //     };
  //   });

  const debounceHandleGetHumans = useRef(
    debounce(async (search?: string, filters?: Filter) => {
      dispatch(
        getHumatarsServer({
          keyword: search,
          pageNumber: 1,
          ...filters,
          isFeMale: filters?.isFeMale.length ? (filters.isFeMale[0] === "Male" ? false : true) : null,
          category: humatarAPIFilters[activeTab],
          bookmarked: activeTab === HumatarProps.SAVED,
        }),
      );
    }, searchTimeoutDelay),
  ).current;

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (windowDimensions.width > 735) {
      setOpenMobileSelectList(false);
    }
  }, [windowDimensions]);

  useEffect(() => {
    dispatch(searchHumatarResultLoading(true));
    dispatch(clearHumatars());
    debounceHandleGetHumans(search, filters);
  }, [search]);

  useEffect(() => {
    if (!isFirstRender.current) {
      dispatch(clearHumatars());
      dispatch(filterHumatarLoading(true));
      dispatch(
        getHumatarsServer({
          keyword: search,
          pageNumber: 1,
          ...filters,
          isFeMale: filters.isFeMale.length ? (filters.isFeMale[0] === "Male" ? false : true) : null,
          popular: screen.popular,
          history: screen.history,
          category: humatarAPIFilters[activeTab],
          bookmarked: activeTab === HumatarProps.SAVED,
        }),
      );
    }
    isFirstRender.current = false;
  }, [screen]);

  const handleActiveTab = (tab: string) => {
    // if (uploadHumatarLoading) return;

    setActiveTab(tab as HumatarProps);
  };

  useEffect(() => {
    dispatch(clearHumatars());
    dispatch(
      getHumatarsServer({
        keyword: "",
        pageNumber: 1,
        category: humatarAPIFilters[activeTab],
        bookmarked: activeTab === HumatarProps.SAVED,
      }),
    );
  }, [activeTab]);

  useEffect(() => {
    dispatch(filterHumatarLoading(true));
    dispatch(clearHumatars());
    debounceHandleGetHumans(search, filters);
  }, [filters]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => setSearch(e.target.value);

  const handleScreenChange = (e: any, key: "popular" | "history" | "bookmark", value: boolean) => {
    e.preventDefault();

    const newValue = {
      [key]: !value,
    };

    setScreen({ popular: false, history: false, bookmark: false, ...newValue });
  };

  const handleActive = (humatar: Humatar) => {
    const isCurrentHumatarActive = active?.aiHumanActorId === humatar.aiHumanActorId;
    if (isCurrentHumatarActive) {
      setActive(active);
    } else {
      setActive(humatar);
    }
  };

  const onSave = () => {
    const newActor = active;

    if (!newActor) {
      toast.error("Choose a humatar");
      return;
    }

    handleAddAvatar(
      newActor?.photo,
      newActor.aiHumanActorId,
      newActor.allowCircle,
      canvasSize,
      newActor.category === "Custom" ? true : false,
      ActorPositionTypes.FullBody,
      newActor.versions,
    );
    handleClose();
  };

  const handleClose = () => {
    dispatch(clearSearch({ category: prefilled?.category }));
    setSearch("");
    onClose();
  };

  const handleFilterDelete = (
    key: "categoryType" | "voiceAge" | "isFeMale" | "mood" | "content" | "region" | "language" | "country",
    item: string,
  ) => {
    const newValue = {
      [key]: filters[key].filter((filter) => filter !== item) || [],
    };

    setFilters({ ...filters, ...newValue });
  };

  const fetchMore = (search: string) => {
    dispatch(
      getHumatarsServer({
        keyword: search,
        pageNumber: currentPage + 1,
        ...filters,
        isFeMale: filters.isFeMale.length ? (filters.isFeMale[0] === "Male" ? false : true) : null,
        category: humatarAPIFilters[activeTab],
        bookmarked: activeTab === HumatarProps.SAVED,
      }),
    );
  };

  const handleBookmarked = (e: any, id: number) => {
    e.stopPropagation();

    const isBookmarked = humans?.find((human) => human.aiHumanActorId === id)?.isBookmarked;

    if (isBookmarked) dispatch(bookmarkHumatarServer(id, false, screen.bookmark));
    else dispatch(bookmarkHumatarServer(id, true));
  };

  const handleCustomHumatarDelete = (e: any, human: Humatar) => {
    if (!human.aiHumanActorId) {
      throw Error(`The actor ID is missing when deleting`);
    }
    e.stopPropagation();
    e.preventDefault();

    const requestForHumatarServer = {
      keyword: search,
      pageNumber: 1,
      ...filters,
      isFeMale: filters.isFeMale.length ? (filters.isFeMale[0] === "Male" ? false : true) : null,
      bookmarked: screen.bookmark,
      popular: screen.popular,
      history: screen.history,
    };

    const previousFill: HumatarPrefilled = { ...(prefilled as HumatarPrefilled), requestForHumatarServer };

    const confirmationPrefilled: ConfirmationDelete = {
      id: human.aiHumanActorId,
      title: `Are you sure you want to delete ${human.name}?`,
      description: `The ${human.name} will be removed and the action cannot be undone`,
      typeId: 1,
      type: DeleteType.CustomHumatar,
      previousFill,
    };

    dispatch(
      updatePopup({
        popup: Popups.confirmationPopup,
        status: true,
        prefilled: confirmationPrefilled,
      }),
    );
  };

  const handlePopupOpen = (e: any, human: Humatar) => {
    e.stopPropagation();

    const prefilled: HumatarPreviewPrefilled = {
      human,
      setSelectedActor,
    };

    dispatch(
      updatePopup({
        popup: Popups.aIHumansPreviewPopup,
        status: true,
        prefilled,
      }),
    );
  };

  return (
    <Modal className="human" title="Avatars" open={open} onClose={handleClose} maxWidth={1214} maxHeight={744}>
      <Content>
        <TabsWrapper>
          <Tabs data={humatarTabs} active={activeTab} handleActive={handleActiveTab} />
        </TabsWrapper>

        <HumansCardsWrapper id="scrollableDiv">
          <InfiniteScroll
            next={() => !searchLoading && !filterLoading && fetchMore(search)}
            hasMore={hasMore}
            loader={isLoading ? <AvtarPopupContentLoader /> : null}
            dataLength={humans?.length}
            style={{ display: "contents" }}
            scrollableTarget="scrollableDiv"
          >
            {humans &&
              humans?.map((human) => {
                const isCurrentHumatarActive = active?.aiHumanActorId === human.aiHumanActorId;
                const versions = human.versions;
                return (
                  <HumanCardWrapper key={human.aiHumanActorId}>
                    {versions && (
                      <ImageTag title={versions} top={-6} right={24}>
                        {versions}.0
                      </ImageTag>
                    )}
                    <NewHumanCard
                      photo={human.photo}
                      name={human.name}
                      isDeleteButton={human.category === "Custom"}
                      isBookmarked={human.isBookmarked}
                      active={isCurrentHumatarActive}
                      isLocked={human.isLocked}
                      handleActive={() => handleActive(human)}
                      handleBookmarked={(e: any) => handleBookmarked(e, human.aiHumanActorId)}
                      handlePlay={(e: any) => handlePopupOpen(e, human)}
                      handleSelect={onSave}
                      handleCustomHumatarDelete={(e: any) => handleCustomHumatarDelete(e, human)}
                    />
                  </HumanCardWrapper>
                );
              })}
          </InfiniteScroll>
        </HumansCardsWrapper>
        {/* <ActionsWrapper>
          <Button text="Cancel" buttonTheme={ButtonThemes.Outline} onClick={handleClose} />
          <Button text="Add" onClick={onSave} />
        </ActionsWrapper> */}
      </Content>
    </Modal>
  );
};

const AvtarPopupContentLoader = ({ count = 5 }) => {
  return (
    <ContentLoaderWrapper>
      {Array.from({ length: count }).map((_, index) => (
        <ContentLoader
          key={index}
          speed={1}
          width={200}
          height={238}
          viewBox="0 0 200 238"
          backgroundColor="#1d1f23"
          foregroundColor="#4c4d4d"
          style={{ borderRadius: "8px" }}
        >
          {/* Circular image loader */}
          <rect x="0" y="0" rx="8" ry="8" width="200" height="160" />
          {/* Text placeholder */}
          <rect x="10" y="170" rx="4" ry="4" width="120" height="20" />
          {/* Small subtitle */}
          <rect x="10" y="200" rx="3" ry="3" width="80" height="16" />
        </ContentLoader>
      ))}
    </ContentLoaderWrapper>
  );
};

const ContentLoaderWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 238px);
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden auto;
  ::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 735px) {
    gap: 15px;
  }

  @media (max-height: 400px) {
    gap: 5px;
  }
`;

const TabsWrapper = styled.div`
  margin-top: 8px;
  max-width: 428px;
  & > div {
    border-radius: 0;
    padding: 0;
    background: none;
    min-height: 40px;
    margin: 0;
    & > button {
      border-radius: 0;
      min-height: 40px;
    }
  }
`;

const HumansCardsWrapper = styled.div`
  padding-top: 12px;
  margin-top: 8px;
  position: relative;
  overflow: hidden auto;
  height: 100%;
  max-height: 100%;
  display: grid;
  align-content: start;
  padding-bottom: 100px;
  row-gap: 24px;

  .infinite-scroll-component__outerdiv {
    display: contents;
  }

  @media (min-width: 1310px) {
    grid-template-columns: repeat(5, 238px);
  }

  @media (min-width: 950px) and (max-width: 1309px) {
    grid-template-columns: repeat(4, 238px);
  }

  @media (max-width: 949px) {
    grid-template-columns: repeat(3, 238px);
  }

  @media (max-width: 849px) {
    grid-template-columns: repeat(2, 238px);
  }

  @media (max-width: 515px) {
    grid-template-columns: repeat(2, 1fr);
  }

  /* @media (min-width: 950px) and (max-width: 1309px) and (max-height: 860px), (max-height: 800px) {
    max-height: 76vh;
  }

   @media (max-width: 949px) and (max-height: 860px) {
    max-height: 58vh;
  }

  @media (max-width: 735px) {
    max-height: 65vh;
    margin-top: 0;
  }

  @media (max-width: 735px) and (max-height: 660px) {
    max-height: 58vh;
    margin-top: 0;
  }

  @media (max-width: 515px) {
    position: inherit;
    max-height: 71vh;
    margin-top: 0;
  }

  @media (max-width: 515px) and (max-height: 760px) {
    max-height: 62vh;
  } */

  @media (max-width: 1001px) {
    ::-webkit-scrollbar {
      display: none;
    }
  }

  ::-webkit-scrollbar {
    /* width: 2px; */
    display: none;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: ${({ theme }) => theme.activeMenu};
  }

  ::-webkit-scrollbar-track {
    margin: 15px 0;
  }
`;

const HumanCardWrapper = styled.div`
  position: relative;
`;

const MobileOnlyFilterButton = styled.div`
  margin-left: 17px;
  cursor: pointer;
  svg {
    width: 20px;
    height: 20px;
  }

  @media (min-width: 736px) {
    display: none;
  }
`;
const MobileOnlyTitleWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  p {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    background: ${({ theme }) => theme.button};
  }
  @media (min-width: 736px) {
    display: none;
  }
`;

const Title = styled.h2`
  font-family: "Mulish", sans-serif;
  color: ${({ theme }) => theme.primaryText};
  letter-spacing: -1px;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;

  @media (max-width: 600px) and (max-height: 400px) {
    font-size: 18px;
    line-height: 22px;
  }
`;

const Heading = styled.div`
  display: flex;
  align-items: end;
  justify-content: space-between;
  margin-bottom: 18px;

  button > span {
    font-size: 12px;
    line-height: 16px;

    @media (max-width: 600px) and (max-height: 400px) {
      font-size: 10px;
      line-height: 14px;
    }
  }

  @media (max-height: 720px) {
    margin-bottom: 14px;

    button > span {
      font-size: 10px;
      line-height: 14px;
    }
  }

  @media (max-width: 735px) {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 24px;
  }

  @media (min-width: 736px) and (max-width: 949px) {
    flex-direction: column;
    align-items: center;
  }

  @media (max-width: 735px) and (max-height: 660px) {
    margin-bottom: 10px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 17px;
  @media (max-width: 949px), (max-height: 800px) {
    margin-bottom: 5px;
  }
`;

const TextfieldWrapper = styled.div`
  width: 320px;

  @media (max-width: 735px) {
    display: flex;
    align-items: center;
    width: 100%;
  }
`;

const Actions = styled.div`
  display: flex;
  column-gap: 24px;
  align-items: center;
`;

const ImportDesktopWrapper = styled.div`
  @media (max-width: 735px) {
    display: none;
  }
`;

const ImportMobileWrapper = styled.div`
  margin-left: 16px;
  margin-bottom: 5px;

  @media (min-width: 736px) {
    display: none;
  }
`;

const Import = styled.div`
  background: linear-gradient(142.13deg, #0063b4 16.78%, #009af7 85.53%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  display: flex;
  column-gap: 4px;
  align-items: center;

  & path {
    fill: #0063b4;
  }
`;

const ImportText = styled.p`
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
`;

const ChipWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: flex-start;
  gap: 12px;
  width: 100%;
  height: 32px;
  overflow: scroll;
  flex-flow: column wrap;
  flex-shrink: 0;

  ::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 735px) {
    display: none;
  }
`;
const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${({ theme }) => theme.characterActionsBackground};
  height: 100px;
  bottom: 0;
  position: absolute;
  width: 100%;
  z-index: 3;

  button {
    width: 161.5px;
  }

  @media (max-width: 515px) and (max-height: 760px) {
    height: 80px;
    width: 99%;
  }

  @media (min-width: 950px) and (max-height: 720px) {
    height: auto;

    button {
      width: 100px;
      max-height: 48px;

      & > span {
        font-size: 14px;
        line-height: 18px;
      }
    }
  }
`;

const CharactersWrapper = styled.div`
  background-color: ${({ theme }) => theme.primaryBackground};
  box-shadow: ${({ theme }) => theme.cardShadow};
  border-radius: 16px;
  position: absolute;
  width: 100%;
  z-index: 10;
  top: 80px;
  border: solid 1px ${({ theme }) => theme.activeMenu};

  svg {
    path {
      fill: ${({ theme }) => theme.activeMenu};
    }
  }
`;

const CharacterCategoryWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 16px 12px 16px 12px;
  border-radius: 16px;
  gap: 8px;
  max-height: 53vh;
  overflow-y: auto;

  @media (max-width: 1001px) {
    ::-webkit-scrollbar {
      display: none;
    }
  }

  ::-webkit-scrollbar {
    /* width: 2px; */
    display: none;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: ${({ theme }) => theme.activeMenu};
  }

  ::-webkit-scrollbar-track {
    margin: 15px 0;
  }
`;

export default AIHumansPopup;
